import {
    MyPartnerParam1,
    MyPartnerView,
    OpDisPartnerParam,
    PojiaChannelCountUsingGetParams,
    GetSubAccountsUsingGetParams,
    CompanyUserManageVo,
    CompanyIdParam,
    GetBindSubAccountListUsingGetParams,
    Logistics,
    StatusNumsUsingGet1Params,
    MyPartnerNum,
    PendingProcessSupplierNumResult,
    MyPartnerParam,
    QueryBillPeriodUsingGet1Params,
    BillPeriodVo,
    SetBillPeriodParam,
    QueryDisCooperationUsingGet1Params,
    DisCooperationVo,
    BatchSetDisLevelParam,
    BatchSetSalesManParam1,
    BatchRefuseParam,
    QueryBalanceParam,
    ChannelQueryBalanceVo,
    QrCodeConfig,
    BatchSetSyncStockParam,
    BindAuthDrpParam,
    BindAuthDrpVo,
    QueryChannelContactInfoUsingGetParams,
    DirectorInfoVo,
    DistrCustomerCenterPageParam,
    ChannelCustomerCenterVo,
    GetPartnerStatsNumVoUsingGet1Params,
    PartnerStatsNumVo,
    QueryVisitorStatCountUsingGetParams,
    VisitorStatCountVo,
    ListOnShelfProductUsingGetParams,
    OnShelfProductVo,
    PartnerListUsingGetParams,
    PartnerInfo,
    MultiCoIdsParam,
    SimplePartnerParam,
    SimplePartnerVo,
    GetDistributionDataForChannelUsingGetParams,
    DistributionDataForChannelResult,
    SimpleChannelInfoVo,
    BatchSetMinPurchaseAmtParam,
    MultiSuppliersParam,
    MinPurchaseResult,
    QueryMyChannelDetailUsingGetParams,
    MyChannelDetailResult,
    QueryMyChannelDetailLogUsingGetParams,
    MyChannelDetailLogResult,
    ModifyMyChannelDetailParam,
    QueryMyWaitConfirmChannelUsingGetParams,
    MyWaitConfirmChannelResult,
    QueryOpenSyncStockLimitResult,
} from '@servicesTypings/drpRequest'
import { drpRequest } from '@/utils/request'
import { getCacheService } from '@/utils/requestUtils'

import {
    SetSyncStockParam,
    Void,
    QuerySyncStockSwitchParams,
    DistrCustomerCenterParam,
    CoopChannelCloseSyncStockParam,
    MyChannelCloseSyncStockParam,
    QueryExpressAgencyDelivingParams,
} from '@servicesTypings/drpRequestV3'

// 获取我的分销商列表  post
/**
 * 我的分销商列表
 */
export function queryMyPartnerListPost(data: MyPartnerParam1): API.Res<MyPartnerView[]> {
    return drpRequest.post('/myPartner/listForPost', { data })
}

// 修改分销商等级
/**
 * 更新分销等级
 */
export function updateDisLevel(data: OpDisPartnerParam): API.Res<object> {
    return drpRequest.post('/myPartner/updateDisLevelByCoId', { data })
}

// 查询合作中的指定有破价订单的我的分销商数量
/**
 * 查询合作中的指定有破价订单的我的分销商数量
 */
export function pojiaChannelCountApi(params: PojiaChannelCountUsingGetParams): API.Res<number> {
    return drpRequest.get('/partner/supplier/pojiaChannelCount', { params })
}

// 修改库存同步
/**
 * 更新同步库存
 */
export function updateStockSync(data: OpDisPartnerParam): API.Res<object> {
    return drpRequest.post('/myPartner/updateSyncStockByCoId', { data })
}

// 修改极速代发开启状态
/**
 * 更新极速代发开关
 */
export function updateExpressAgencyDeliving(data: OpDisPartnerParam): API.Res<boolean> {
    return drpRequest.post('/myPartner/updateExpressAgencyDeliving', { data })
}

// 审核拒绝
/**
 * 拒绝合作(供应商调用)
 */
export function refuse(data: OpDisPartnerParam): API.Res<object> {
    return drpRequest.post('/myPartner/refuseByCoId', { data })
}

// 审核通过
export function pass(data) {
    return drpRequest.post('/myPartner/applyByCoId', { data })
}
// 查询业务员列表
/**
 * 查询商家的用户列表
 */
export function fetchSubAccountListApi(params: GetSubAccountsUsingGetParams): API.Res<CompanyUserManageVo[]> {
    return drpRequest.get('/subAccount/getSubAccounts', { params })
}

// 设置业务员
/**
 * 设置业务员
 */
export function updateSupplierUserName(data: CompanyIdParam): API.Res<object> {
    return drpRequest.post('/myPartner/setSalesman', { data })
}

// 查询已设置的业务员列表
/**
 * 查询已设置的业务员列表
 */
export function fetchBindSubAccountListApi(
    params: GetBindSubAccountListUsingGetParams,
): API.Res<CompanyUserManageVo[]> {
    return drpRequest.get('/subAccount/getBindSubAccountList', { params })
}

// 查询快递公司
/**
 * 渠道获取已绑定的快递公司
 */
export function queryLogistics(): API.Res<Logistics[]> {
    return drpRequest.get('/channel/logistics/list')
}

// 查询我的分销商不同状态数量
/**
 * 已合作、待审核、待授权数量
 */
export function myPartnerStatusNum(params: StatusNumsUsingGet1Params): API.Res<MyPartnerNum> {
    return drpRequest.get('/myPartner/statusNums', { params })
}

// 待处理供应商数量
/**
 * 待处理供应商数量
 */
export function getPendingProcessSupplierNum(): API.Res<PendingProcessSupplierNumResult> {
    return drpRequest.get('/inviteRecent/getPendingProcessSupplierNumV2')
}

// 按条件导出我的分销商数据
/**
 * 按条件导出我的分销商数据
 */
export function exportMyChannelByCondition(data: MyPartnerParam): API.Res<string> {
    return drpRequest.post('/partner/supplier/exportMyChannelByCondition', { data })
}

// 查询账期设置
/**
 * 查询账期设置
 */
export function queryBillPeriod(params: QueryBillPeriodUsingGet1Params): API.Res<BillPeriodVo> {
    return drpRequest.get('/myPartner/queryBillPeriod', { params })
}

// 修改账期设置
/**
 * 修改账期设置
 */
export function setBillPeriod(data: SetBillPeriodParam): API.Res<object> {
    return drpRequest.post('/myPartner/setBillPeriod', { data })
}

// 查询当前商家是否开启了极速合作
/**
 * 当前商家是否开通极速合作
 */
export function hasSetFastCooperationApi(): API.Res<boolean> {
    return drpRequest.get('/supplier/hasSetFastCooperation')
}

// 查询合作状态及供应商是否开启允许分销商极速合作
/**
 * 查询合作状态及供应商是否开启允许分销商极速合作
 */
export function queryDisCooperation(params: QueryDisCooperationUsingGet1Params): API.Res<DisCooperationVo> {
    return drpRequest.get('/myPartner/queryDisCooperation', { params })
}

// 批量修改分销等级
/**
 * 批量修改分销等级
 */
export function batchSetDisLevel(data: BatchSetDisLevelParam): API.Res<null> {
    return drpRequest.post('/partner/supplier/batchSetDisLevel', { data })
}

// 批量修改业务员
/**
 * 批量修改业务员
 */
export function batchSetSalesMan(data: BatchSetSalesManParam1): API.Res<null> {
    return drpRequest.post('/partner/supplier/batchSetSalesMan', { data })
}

// 批量拒绝分销商的申请
/**
 * 批量拒绝分销商的申请
 */
export function batchRefuse(data: BatchRefuseParam): API.Res<null> {
    return drpRequest.post('/partner/supplier/batchRefuse', { data })
}

// 批量查询用户与对应分销商的分销资金余额
/**
 * 批量查询用户在对应供销商的分销资金
 */
export function queryBalance(data: QueryBalanceParam): API.Res<ChannelQueryBalanceVo[]> {
    return drpRequest.post('/funds/management/supplier/queryBalanceBySupplier', { data })
}

// 批量同意分销商的申请，建立合作关系
export function batchConfirm(data) {
    return drpRequest.post('/partner/supplier/batchConfirm', { data })
}

// 商家手机扫码看货生成小程序码配置
/**
 * 商家手机扫码看货生成小程序码配置
 */
export function queryWxQRConfig(): API.Res<QrCodeConfig> {
    return drpRequest.get('/config/qrConfig')
}

// 商家手机扫码看货生成小程序码配置
/**
 * 修改商家手机扫码看货生成小程序码配置
 */
export function updateWxQRConfig(data: QrCodeConfig): API.Res<null> {
    return drpRequest.post('/config/qrConfig', { data })
}

// 批量设置库存同步状态
// {
//   "channelCoIdList": [],
//   "syncStock": true
// }
/**
 * 批量设置库存同步状态
 */
export function batchSetSyncStock(data: BatchSetSyncStockParam): API.Res<null> {
    return drpRequest.post('/partner/supplier/batchSetSyncStock', { data })
}

// 绑定业务员与分销商权限
/**
 * 绑定业务员与分销商权限
 */
export function bindAuthDrp(data: BindAuthDrpParam): API.Res<BindAuthDrpVo> {
    return drpRequest.post('/partner/supplier/bindAuthDrp', { data })
}

// 查询分销商的找货负责人信息
/**
 * 查询分销商的找货负责人信息
 */
export function queryChannelContactInfo(params: QueryChannelContactInfoUsingGetParams): API.Res<DirectorInfoVo> {
    return drpRequest.get('/partner/supplier/queryChannelContactInfo', { params })
}

// 客户管理中心列表接口
/**
 * swagger找不到此接口
 */
export function queryChannelCustomerCenterList(params) {
    return drpRequest.get('/channelCustomerCenter/list', {
        params,
    })
}

// 客户管理中心列表接口  post
/**
 * 列表
 */
export function queryChannelCustomerCenterListPost(
    data: DistrCustomerCenterPageParam,
): API.Res<ChannelCustomerCenterVo[]> {
    return drpRequest.post('/channelCustomerCenter/listForPost', { data })
}

// 获取场景化筛选分销商数量
/**
 * 获取场景化筛选分销商数量
 */
export function queryPartnerStatsNum(params: GetPartnerStatsNumVoUsingGet1Params): API.Res<PartnerStatsNumVo> {
    return drpRequest.get('/channelCustomerCenter/getPartnerStatsNumVo', { params })
}

// 近 30 天待开发客户数量
/**
 * 待开发客户数量(默认近30天)
 */
export function queryVisitorStatCount(params: QueryVisitorStatCountUsingGetParams): API.Res<VisitorStatCountVo> {
    return drpRequest.get('/visitorInfo/queryVisitorStatCount', { params })
}

// 获取分销商客户中心数据最新同步时间,以及本周，本月数据是否可用（如果是本周，本月的第一天上午，可能数据还是上周上月的）
export function getChannelCustomerCenterLastSyncDateInfo() {
    return drpRequest.get('/channelCustomerCenter/getChannelCustomerCenterSyncInfo')
}

// 查询供应商近7天终止合作数量
export function getCancelSupplierNum(params) {
    const drpRequestCache = getCacheService(drpRequest)
    return drpRequestCache.get('/mySupplier/getCancelSupplierNum', {
        params,
    })
}

// 分页查询上架商品明细
/**
 * 分页查询上架商品明细
 */
export function getOnShelfProductcDate(params: ListOnShelfProductUsingGetParams): API.Res<OnShelfProductVo[]> {
    return drpRequest.get('/channelCustomerCenter/listOnShelfProduct', { params })
}

// 查询我的分销商的合伙人信息列表
/**
 * 查询我的分销商的合伙人信息列表
 */
export function getPartnerList(params: PartnerListUsingGetParams): API.Res<PartnerInfo[]> {
    return drpRequest.get('/partner/supplier/partnerList', { params })
}

// 查询合伙人信息
/**
 * 查询合伙人信息
 */
export function queryPartnersInfo(data: MultiCoIdsParam): API.Res<PartnerInfo[]> {
    return drpRequest.post('/partner/supplier/queryPartnersInfo', { data })
}

// 查询我的分销商下拉列表使用
/**
 * 查询我的分销商下拉列表使用
 */
export function myChannelForSelect(data: SimplePartnerParam): API.Res<SimplePartnerVo[]> {
    return drpRequest.post('/partner/supplier/myChannelForSelect', { data })
}

// 查询与合作供应商的分销数据
/**
 * 查询与合作供应商的分销数据
 */
export function getDistributionDataForChannel(
    params: GetDistributionDataForChannelUsingGetParams,
): API.Res<DistributionDataForChannelResult> {
    return drpRequest.get('/partner/channel/getDistributionDataForChannel', { params })
}

// 根据名称查询我的分销商列表(精确匹配)
/**
 * 根据名称查询我的分销商列表(精确匹配)
 */
export function listChannelByCoNames(data: string[]): API.Res<SimpleChannelInfoVo[]> {
    return drpRequest.post('/myPartner/listChannelByCoNames', { data })
}

/**
 * 批量设置起采金额
 */
/**
 * 批量设置起采金额
 */
export function batchSetMinPurchaseAmt(data: BatchSetMinPurchaseAmtParam): API.Res<null> {
    return drpRequest.post('/partner/supplier/batchSetMinPurchaseAmt', { data })
}

/**
 * 查询供应商起采金额
 */
/**
 * 查询供应商起采金额
 */
export function queryMinPurchaseAmt(data: MultiSuppliersParam): API.Res<MinPurchaseResult[]> {
    return drpRequest.post('/partner/channel/queryMinPurchaseAmt', { data })
}

/** 查询默认起采信息接口返回 */
export interface QueryMinPurchaseAmtResponse {
    /** 供应商 ID */
    coId: string

    /** 起采金额 */
    minPurchaseAmt: number

    /** 起采数量 */
    minPurchaseCount: number
}

/** 查询默认起采信息 */
export function queryDefaultMinPurchaseInfo(): API.Res<QueryMinPurchaseAmtResponse> {
    return drpRequest.get('/disConfig/queryDefaultMinPurchaseInfo')
}

/** 设置默认起采信息接口参数 */
export interface SetDefaultMinPurchaseInfoParams {
    /** 起采金额 */
    minPurchaseAmt?: number

    /** 起采数量 */
    minPurchaseCount?: number
}

/** 设置默认起采信息 */
export function setDefaultMinPurchaseInfo(data: SetDefaultMinPurchaseInfoParams): API.Res<void> {
    return drpRequest.post('/disConfig/setDefaultMinPurchaseInfo', { data })
}

/**
 * 查询我的分销商详情信息
 */
export function queryMyChannelDetailUsingGET(
    params: QueryMyChannelDetailUsingGetParams,
): API.Res<MyChannelDetailResult> {
    return drpRequest.get('/partner/supplier/queryMyChannelDetail', { params })
}

/**
 * 查询我的分销商详情修改日志信息
 */
export function queryMyChannelDetailLogUsingGET(
    params: QueryMyChannelDetailLogUsingGetParams,
): API.Res<MyChannelDetailLogResult[]> {
    return drpRequest.get('/partner/supplier/queryMyChannelDetailLog', { params })
}

/**
 * 修改我的分销商详情信息
 */
export function modifyMyChannelDetailUsingPOST(data: ModifyMyChannelDetailParam): API.Res<null> {
    return drpRequest.post('/partner/supplier/modifyMyChannelDetail', { data })
}

/**
 * queryMyWaitConfirmChannel
 */
export function queryMyWaitConfirmChannelUsingGET(
    params: QueryMyWaitConfirmChannelUsingGetParams,
): API.Res<MyWaitConfirmChannelResult[]> {
    return drpRequest.get('/myChannel/queryMyWaitConfirmChannel', { params })
}

/**
 * 申请-同意合作时,校验是否超过供应商可开启库存同步上限
 */
export function checkExceedSyncStockLimitUsingGET(params): API.Res<null> {
    return drpRequest.get('/myChannel/checkExceedSyncStockLimit', { params })
}

/**
 * 查询供应商开启库存同步限制信息(合作中)
 */
export function queryOpenSyncStockLimitUsingGET(): API.Res<QueryOpenSyncStockLimitResult> {
    return drpRequest.get('/supplier/queryOpenSyncStockLimit')
}

/**
 * 查询符合条件的分销商数量
 */
export function queryMyChannelCount(data: DistrCustomerCenterParam): API.Res<Long> {
    return drpRequest.post('/channelCustomerCenter/queryMyChannelCount', { data })
}

/**
 * 修改库存同步
 */
export function batchSetSyncStock1(data: SetSyncStockParam): API.Res<Void> {
    return drpRequest.post('/channelCustomerCenter/batchSetSyncStock', { data })
}

/**
 * 分销客户中心按查询条件关闭库存同步开关
 */
export function closeSyncStock1(data: CoopChannelCloseSyncStockParam): API.Res<Void> {
    return drpRequest.post('/channelCustomerCenter/closeSyncStock', { data })
}

/**
 * 我的分销商按查询条件关闭库存同步开关
 */
export function closeSyncStock(data: MyChannelCloseSyncStockParam): API.Res<Void> {
    return drpRequest.post('/partner/supplier/closeSyncStock', { data })
}

/**
 * 查询我的分销商库存同步开关状态
 */
export function querySyncStockSwitch(params: QuerySyncStockSwitchParams): API.Res<Boolean> {
    return drpRequest.get('/myChannel/querySyncStock', { params })
}

/**
 * 查询同时开启了库存同步和极速代发的分销商数量
 */
export function queryStockAndDeliveryConflictNum(): API.Res<Long> {
    return drpRequest.get('/myChannel/queryStockAndDeliveryConflictNum')
}

/**
 * 批量关闭极速代发--库存同步和极速代发冲突的分销商
 */
export function closeDeliveryForConflictChannel(): API.Res<Void> {
    return drpRequest.post('/myChannel/update/closeDeliveryForConflictChannel')
}

/**
 * 批量关闭库存同步--库存同步和极速代发冲突的分销商
 */
export function closeStockForConflictChannel(): API.Res<Void> {
    return drpRequest.post('/myChannel/update/closeStockForConflictChannel')
}

/**
 * 查询我的分销商极速代发开关状态
 */
export function queryExpressAgencyDeliving(params: QueryExpressAgencyDelivingParams): API.Res<Boolean> {
    return drpRequest.get('/myChannel/queryExpressAgencyDeliving', { params })
}
